module.exports = __webpack_public_path__ + "img/btn_noti_active.71b51893.svg";